/*
  * Copyright Mission 42 Ventures, Inc. All rights reserved.
  * Unauthorized copying, distribution, or use is prohibited.
  */

import React from 'react';
import { SidebarItem } from '@backstage/core-components';
import SecurityIcon from '@material-ui/icons/Security';
import { useNetworkPolicyAccess } from '../networkPolicy/useNetworkPolicyApi';

/**
 * Sidebar entry for the Service Access page (network policy L4 + mesh
 * authorization L7). Reads are open to any authenticated user, so the probe
 * only hides the item while signed out (or when the backend plugin is
 * unavailable). Both tabs are served by the network-policy plugin, so its
 * access probe gates the whole surface.
 */
export const NetworkPolicySidebarItem = () => {
  const { allowed } = useNetworkPolicyAccess();
  if (!allowed) return null;
  return (
    <SidebarItem
      icon={SecurityIcon}
      to="/service-access/network"
      text="Access"
    />
  );
};
